import { DaDataResponse } from '@company/const';
import { StateUtils } from '@spartacus/core';
import { SEARCH_COMPANY_ENTITY } from '../company-state';

export const SEARCH_COMPANY = '[Company] Search Company';
export const SEARCH_COMPANY_SUCCESS = '[Company] Search Company Success';
export const SEARCH_COMPANY_FAIL = '[Company] Search Company Fail';
export const SEARCH_COMPANY_RESET = '[Company] Search Company Reset';

export class SearchCompany extends StateUtils.LoaderLoadAction {
  readonly type = SEARCH_COMPANY;

  constructor(public payload: string) {
    super(SEARCH_COMPANY_ENTITY);
  }
}

export class SearchCompanySuccess extends StateUtils.LoaderSuccessAction {
  readonly type = SEARCH_COMPANY_SUCCESS;

  constructor(public payload: DaDataResponse[]) {
    super(SEARCH_COMPANY_ENTITY);
  }
}

export class SearchCompanyFail extends StateUtils.LoaderFailAction {
  readonly type = SEARCH_COMPANY_FAIL;

  constructor() {
    super(SEARCH_COMPANY_ENTITY);
  }
}

export class SearchCompanyReset extends StateUtils.LoaderResetAction {
  readonly type = SEARCH_COMPANY_RESET;

  constructor() {
    super(SEARCH_COMPANY_ENTITY);
  }
}

export type SearchCompanyActions = SearchCompany | SearchCompanySuccess | SearchCompanyFail | SearchCompanyReset;
